import { Dispatch, SetStateAction } from 'react';
import ExternalAnalysisPanel from '../../../components/ExternalAnalysisPanel';
import ExternalAnalysisStatus from '../../../components/ExternalAnalysisStatus';
import { Episode, Project, ScriptAnalysis } from '../../../types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface ExternalAnalysisSectionProps {
  project: Project;
  projectId: string;
  analysis: ScriptAnalysis | null;
  episodes: Episode[];
  externalTaskId: string | null;
  lastFailedExternalTaskId: string | null;
  lastFailedExternalReason: string | null;
  t: Translate;
  toast: {
    error: (message: string) => void;
  };
  setExternalTaskId: Dispatch<SetStateAction<string | null>>;
  setLastFailedExternalTaskId: Dispatch<SetStateAction<string | null>>;
  setLastFailedExternalReason: Dispatch<SetStateAction<string | null>>;
  loadProject: (projectId: string) => void;
}

export default function ExternalAnalysisSection({
  project,
  projectId,
  analysis,
  episodes,
  externalTaskId,
  lastFailedExternalTaskId,
  lastFailedExternalReason,
  t,
  toast,
  setExternalTaskId,
  setLastFailedExternalTaskId,
  setLastFailedExternalReason,
  loadProject,
}: ExternalAnalysisSectionProps) {
  if (analysis?.status === 'completed') return null;

  return (
    <div className="card" id="external-analysis-section">
      {externalTaskId === null ? (
        <ExternalAnalysisPanel
          projectId={projectId}
          scriptReady={project.script?.status === 'completed'}
          pronounsResolved={!episodes.some(episode =>
            episode.status === 'pending_pronoun_resolve' ||
            episode.status === 'resolving_pronouns' ||
            episode.status === 'resolving_pronouns_failed'
          )}
          activeTaskId={lastFailedExternalTaskId}
          lastFailureReason={lastFailedExternalReason}
          onTriggered={(taskId) => {
            setExternalTaskId(taskId);
            setLastFailedExternalTaskId(null);
            setLastFailedExternalReason(null);
          }}
        />
      ) : (
        <ExternalAnalysisStatus
          projectId={projectId}
          taskId={externalTaskId}
          onCompleted={() => {
            setExternalTaskId(null);
            setLastFailedExternalTaskId(null);
            setLastFailedExternalReason(null);
            loadProject(projectId);
          }}
          onFailed={(reason) => {
            toast.error(t('analysis.externalAnalysisFailed', { reason }));
            setLastFailedExternalTaskId(externalTaskId);
            setLastFailedExternalReason(reason);
            setExternalTaskId(null);
            loadProject(projectId);
          }}
        />
      )}
    </div>
  );
}
